import {Component, OnInit} from '@angular/core';
import {HttpApiService} from "../../../../services/http-api.service";
import {UserService} from "../../../../services/user.service";
import {EndpointsService} from "../../../../services/endpoints.service";

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html'
})
export class UpdatePasswordComponent implements OnInit {

  user: any = {};
  hasError: boolean;
  isUpdated: boolean;
  errorMessage: any;
  confirmPassword: string;

  constructor(private Api: HttpApiService,
              private userService: UserService,
              private endpoints: EndpointsService) {
  }

  ngOnInit() {
    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
      });
  }

  updatePassword(user, confirmPassword) {
    this.errorMessage={};
    this.hasError = false;
    this.isUpdated = false;
    if (user.newPassword != confirmPassword) {
      this.errorMessage="Confirm Password don't match";
      this.hasError = true;
      return false;
    }
    this.Api.put(this.endpoints.getUpdatePasswordUrl(), user, true)
      .subscribe(response => {
          this.isUpdated = true;
        },
        error => {
          this.hasError = true;
          this.errorMessage = JSON.parse(error._body).message;
        });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/user/update-password/update-password.component.ts